import React from 'react';
import Card from "react-bootstrap/Card";

const Aboutme = () => {
return (
    <div className= "aboutmemain">
        
      <div className="mainabout">
          <div className="mainHeadingAbout">
              Bio
          </div>
          <Card className="carddisplay4 news-card" style={{  width:'80hh' }}>
            <Card.Body>
              <div>
                <Card.Text >
                   <b>Currently working as Software Developer at Nokia, Ottawa, Canada</b><br></br>
                   2+ years of Software Engineering Experience working in RnD & DevOps in fast paced Agile team <br></br><br></br>
                   <b>Technical Skills</b><br></br>
                   <b>Programming Languages/Frameworks:</b> Java, C++, Python(Machine learning, Deep learning), React JS<br></br>
                   <b>Operating Systems:</b> Mac OSX, Windows, Linux <br></br>
                   <b>Software Applications/Tools:</b> Kubernetes, Visual Studio Code, Postman, Android Studio, Anaconda Navigator<br></br>
                   <b>Databases:</b> SQLite, MySQL, MongoDB, Firebase realtime database
                </Card.Text>
              </div>
          </Card.Body>
          </Card>

          <div className="biocardsmain">


      <Card className="carddisplay3 news-card" style={{  width:'80hh' }}>

<Card.Body>
  
<div>
  <Card.Text >

{/* A passionate Computer Science Engineer with the hunger for knowledge and challenging problems.<br></br>  */}
<b>Credentials(at a glance):</b><br></br>
<ol>
<li>Deployed 3 websites and 2 Android apps in Playstore.</li>
<li>Published 9 research papers in the reputed journals</li>
<li>Developed a mobile application to predict insulin intake for helping Type-1 diabetes patients.</li>
The app has 1+ Million hits in the database
</ol>

    </Card.Text>
  </div>
</Card.Body>
</Card>
        
<Card className="carddisplay3 news-card" style={{  width:'80hh' }}>

<Card.Body>
  
<div>
  <Card.Text >
  <b>Education :- </b><br></br>
  <ol>
    <li>Masters from Department of Computer Science, UWindsor, Canada</li>
    September 2021 - Dec 2022, GPA- 89%
    <li>Computer Science and Engineering, GGSIPU, India</li>
    2016 - 2020, Graduated with 87.6%
  
  </ol>
</Card.Text>
  </div>
</Card.Body>
</Card>


      </div>
      


      
        
        
      <div className="mainHeadingAbout">
            Recommendations
        </div>
      <div className="biocards">
      <Card className="carddisplay5 news-card" style={{  width:'80hh' }}>
          <Card.Body>
            <div>
                <Card.Text >
                  <div style={{  textAlign:'center' }}>
                      <b>Dr. Saeed Samet<br></br>
                      Associate Professor, University of Windsor, Canada<br></br>Email: saeed.samet@uwindsor.ca</b><br></br><br></br>
                  </div>
                 
                    
                    <i>"Jatin is one of the talented MAC students we have had at our School of Computer Science. He voluntarily helped us train our ICPC (International Collegiate Programming Contest) teams and prepare them for the local and regional contests. He is a very well-organized and hard-working student, with strong programming and software development knowledge and skills. He would be a valuable asset in his workplace based on his perseverance, excellent attitude, and work ethic."</i>
              </Card.Text>
            </div>
          </Card.Body>
        </Card>
     

        <Card className="carddisplay5 news-card" style={{  width:'80hh' }}>
          <Card.Body>
            <div>
                <Card.Text >
                    <div style={{  textAlign:'center' }}>
                      <b>Dr. Savita Ahlawat<br></br>
                      Associate Professor, IP University, India<br></br>Email: savita.ahlawat@msit.in</b><br></br><br></br>
                  </div>
                 
                    
                    <i>"I have taught him machine learning during his undergraduate in Computer Science and Engineering. My association with him has been for more than 2 years. I am Chapter Advisor of the IEEE Computer Society MSIT and Jatin was part of the society for about 2 years holding the position of general secretary for a year and then Vice-chairperson for the next year. I was impressed by his confidence, technical skills, and his enthusiasm for making an impact by sharing his knowledge. For instance, he has taught college students Android app development by taking weekly sessions under the IEEE MSIT Society for a year."</i>
              
              </Card.Text>
            </div>
          </Card.Body>
        </Card>
     
      </div>
       




        </div>
        
        
    </div>
)
}

export default Aboutme;
